import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ButtonWithUberDialog } from '~src/common/react/components/ButtonWithUberDialog';
import { imgPath } from '~src/common/utilities/ImgUrl';

import { FlowSubscriptionDialogContent, FlowSubscriptionDialogContentProps } from './FlowSubscriptionDialogContent';

export type FlowSubscriptionButtonWithDialogProps = FlowSubscriptionDialogContentProps & {
  readonly shouldSendEmailWhenDone: boolean;
  readonly onDialogClose: () => void;
}

export const FlowSubscriptionButtonWithDialog: React.FC<FlowSubscriptionButtonWithDialogProps>  = (props: FlowSubscriptionButtonWithDialogProps) => {
  return (
    <ButtonWithUberDialog
      renderButton={showDialog => (
        <ButtonWidget
          testId={'flow-subscription-edit-button'}
          buttonType={ButtonType.Icon}
          title={Messages.flowSubscriptionsEditButton()}
          onClick={showDialog}
          disabled={!props.shouldSendEmailWhenDone}
          style={{
            padding: `${TabStyles.Spacing.SmallSpace}px`,
            marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
          }}
        >
          <img src={imgPath('menu_edit.svg')} alt={''} />
        </ButtonWidget>
      )}
      dialogWidth={500}
      uberDialogContent={
        <FlowSubscriptionDialogContent
          shouldSendToMe={props.shouldSendToMe}
          onShouldSendToMeToggled={props.onShouldSendToMeToggled}
          subjectValue={props.subjectValue}
          onSubjectChange={props.onSubjectChange}
          messageValue={props.messageValue}
          onMessageChange={props.onMessageChange}
        />
      }
      onDialogClose={props.onDialogClose}
    />
  );
};

FlowSubscriptionButtonWithDialog.displayName = 'FlowSubscriptionButtonWithDialog';
